import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Input, Row, Select, Space, Table, Tag } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import SuperAdminContext, {
  SuperAdminTransactionRow,
} from "../../context/SuperAdminContext";
import { CardComponent, ColumnComponent } from "../../components/ui";

export const SuperAdminTransactionsPage = () => {
  const { transactionRows, superAdminLoading, getTransactionCounts } =
    useContext(SuperAdminContext);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState<string | undefined>();

  useEffect(() => {
    getTransactionCounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = useMemo(
    () =>
      transactionRows.filter((row) => {
        const matchesSearch = row.company.name
          .toLowerCase()
          .includes(search.toLowerCase());
        const matchesStatus =
          !status ||
          (status === "active" && row.company.active) ||
          (status === "suspended" && !row.company.active);
        return matchesSearch && matchesStatus;
      }),
    [transactionRows, search, status],
  );

  const columns: ColumnsType<SuperAdminTransactionRow> = [
    {
      title: "Company",
      dataIndex: ["company", "name"],
      key: "company",
      fixed: "left",
    },
    {
      title: "Status",
      dataIndex: ["company", "active"],
      key: "status",
      render: (active) => (
        <Tag color={active ? "green" : "orange"}>
          {active ? "Active" : "Suspended"}
        </Tag>
      ),
    },
    { title: "Invoices", dataIndex: "invoices", key: "invoices", align: "right" },
    {
      title: "Journal Entries",
      dataIndex: "journalEntries",
      key: "journalEntries",
      align: "right",
    },
    { title: "Deposits", dataIndex: "deposits", key: "deposits", align: "right" },
    { title: "Payments", dataIndex: "payments", key: "payments", align: "right" },
    {
      title: "Credit Memos",
      dataIndex: "creditMemos",
      key: "creditMemos",
      align: "right",
    },
    {
      title: "Total Active",
      dataIndex: "totalActive",
      key: "totalActive",
      align: "right",
      render: (value) => <strong>{value}</strong>,
    },
  ];

  return (
    <div className="super-admin">
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <CardComponent
            className="summary-client__card"
            title="Active Transactions by Company"
            extra={
              <Space className="super-admin__filters" wrap>
                <Input.Search
                  allowClear
                  placeholder="Search companies"
                  onChange={(event) => setSearch(event.target.value)}
                  style={{ minWidth: 220 }}
                />
                <Select
                  allowClear
                  placeholder="Subscription status"
                  value={status}
                  onChange={setStatus}
                  style={{ minWidth: 180 }}
                  options={[
                    { label: "Active", value: "active" },
                    { label: "Suspended", value: "suspended" },
                  ]}
                />
                <Button icon={<ReloadOutlined />} onClick={getTransactionCounts}>
                  Refresh
                </Button>
              </Space>
            }
          />
        </ColumnComponent>
        <ColumnComponent>
          <Table
            bordered
            size="small"
            rowKey={(row) => row.company._id}
            columns={columns}
            dataSource={rows}
            loading={superAdminLoading}
            scroll={{ y: "70vh", x: "100%" }}
          />
        </ColumnComponent>
      </Row>
    </div>
  );
};
